import {fetch} from "utils/dataAccess";

// null clears the rank of the product on its retailer page
export default function updateProductRanking(productId, ranking) {
    // noThrow: an inline field save must reject quietly (the field reverts),
    // never trigger dataAccess's global /404 // /error redirects
    return fetch(`/products/${productId}/ranking`, {
        method: "PUT",
        body: JSON.stringify({ranking}),
    }, false, true);
}
